"use strict";import{FieldLabel as e}from"./src/FieldLabel.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-field-label",e);
//# sourceMappingURL=sp-field-label.js.map
